export const SET_ACTIVE_TABS = 'SET_ACTIVE_TABS';